import { format, parseISO } from 'date-fns'

/**
 * The URL/wire date format (YYYY-MM-DD) used by every admin date-range filter.
 *
 * Serialize and parse as a LOCAL calendar day, not via UTC.
 * `toISOString().slice(0,10)` would project the picker's local Date through
 * UTC and shift the day for negative-offset timezones (e.g. picking Jan 1 in
 * New York → URL stores `2026-01-02` because `endOfDay(local)` rolls to the
 * next UTC day; the BE would receive a `date_to` shifted by a day).
 * `format(d, 'yyyy-MM-dd')` is local; `parseISO` of a date-only string
 * returns a local Date — symmetric, no skew.
 */
export const toDateStr = (d: Date) => format(d, 'yyyy-MM-dd')

export const fromDateStr = (s: string) => parseISO(s)
